import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "../components/Layout";
import Home from "../pages/Home";
import Products from "../pages/Products";
import Packages from "../pages/Packages";
import Contact from "../pages/Contact";
import Login from "../pages/Login";
import Signup from "../pages/Signup";
import Cart from "../pages/Cart";

import AdminLogin from "../adminpanel/AdminLogin";
import AdminPanel from "../adminpanel/AdminPanel";
import AdminDashboard from "../adminpanel/AdminDashboard";
import AllProducts from "../adminpanel/AllProducts";
import AllPackages from "../adminpanel/AllPackages";
import SponsorshipPage from '../pages/SponsorShip';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import RefundPolicy from '../pages/RefundPolicy';
import TermsandConditions from '../pages/TermsandConditions'; 
import Faqs from "../pages/Faqs";
const PrivateAdminRoute = ({ children }) => {
  const sessionItem = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
  if (!sessionItem) {
    return <Navigate to="/admin-login" replace />;
  }
  try {
    atob(sessionItem);
    return children;
  } catch {
    sessionStorage.removeItem("H7Z4L9VD2XK5JW8QRYT6");
    return <Navigate to="/admin-login" replace />;
  }
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes with Layout */}
      <Route
        path="/"
        element={
          <Layout>
            <Home />
          </Layout>
        }
      />
        <Route
          path="/privacy-policy"
          element={
            <Layout>
           <PrivacyPolicy/>
            </Layout>
          }
        />
        <Route
          path="/refund-policy"
          element={
            <Layout>
           <RefundPolicy/>
            </Layout>
          }
        />
        <Route
          path="/terms-conditions"
          element={
            <Layout>
     <TermsandConditions/>
            </Layout>
          }
        />
   <Route
        path="/faqs"
        element={
          <Layout>
            <Faqs />
          </Layout>
        }
      />
      <Route
        path="/products"
        element={
          <Layout>
            <Products />
          </Layout>
        }
      />
      <Route
        path="/packages"
        element={
          <Layout>
            <Packages />
          </Layout>
        }
      />
      <Route
        path="/contact"
        element={
          <Layout>
            <Contact />
          </Layout>
        }
      />
      <Route
        path="/login"
        element={
          <Layout>
            <Login />
          </Layout>
        }
      />
      <Route
        path="/signup"
        element={
          <Layout>
            <Signup />
          </Layout>
        }
      />
      <Route
        path="/cart"
        element={
          <Layout>
            <Cart />
          </Layout>
        }
      />
        <Route
        path="/sakhi-sponsor"
        element={
          <Layout>
           <SponsorshipPage/>
          </Layout>
        }
      />

      {/* Admin Login - Public */}
      <Route path="/admin-login" element={<AdminLogin />} />

      {/* Protected Admin Panel - All sub-routes handled inside AdminPanel */}
      <Route
        path="/admin-panel/*"
        element={
          <PrivateAdminRoute>
            <AdminPanel />
          </PrivateAdminRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="products" element={<AllProducts />} />
        <Route path="packages" element={<AllPackages />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
